import styles from './Fastq.module.scss';
import { TpAutoFormDef, promptAutoForm } from '../auto-form-modal/AutoForm';
import { uploadTemplate } from '../../api/models/assets';
import { UploadFile } from './helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function getDefaultFastQRegex() {
  // TODO: if always preceded by an upload table manifest, base the regex
  // on the pattern specified there
  const fastQFileRegEx = /^(.+?)_(([IR]\d+)|(SE))/;
  return fastQFileRegEx;
}

export function validateFastQFileName(fileName: string) {
  return getDefaultFastQRegex().test(fileName);
}

export function createFastQPairs(files: UploadFile[], filePatterns: any[]) {
  const pairedFastQs: any = {};
  for (const file of files) {
    if (validateFastQFileName(file.name)) {
      for (const pattern of filePatterns) {
        for (const filePattern of pattern.patterns) {
          const match = file.name.match(filePattern);
          if (match) {
            const [, sampleName] = match;
            if (!pairedFastQs[sampleName]) {
              pairedFastQs[sampleName] = { files: {}, sampleId: sampleName };
            }
            if (!pairedFastQs[sampleName].files[pattern.propertyId]) {
              pairedFastQs[sampleName].files[pattern.propertyId] = { selected: file, options: [file] };
            } else {
              pairedFastQs[sampleName].files[pattern.propertyId].options.push(file);
            }
          }
        }
      }
    }
  }

  return pairedFastQs;
}

export function getFastQTable(
  pairedFastQs: any,
  selectedTemplate: uploadTemplate,
  setSamplePairs: (newValue: any) => void,
  onRowClick: (row: any) => void,
  validationCheck: boolean,
) {
  let headerElements = [...selectedTemplate.fileSetMetadata];
  if (selectedTemplate.filePatterns.length > 1) {
    headerElements = [{ id: 'files', name: 'Files', width: 350 }, ...headerElements];
  }
  const headers = headerElements.map((element: any, index: number) => (
    <th key={element.id} style={{ width: `${element.width}px`, textAlign: 'left' }}>
      <i>{element.name}</i>
    </th>
  ));
  headers.push(
    <th key="actions" className={styles.actionsColumn}>
      <i></i>
    </th>,
  );
  const dataTable: { headers: any[]; rows: any[] } = {
    headers: headers,
    rows: Object.entries(pairedFastQs).map(([key, value]) => {
      return (
        <tr key={`${key}-files-overview-table`}>
          {headerElements.map((headerElement: any, i: number) => {
            return (
              <td key={headerElement.id}>
                {headerElement.id === 'files' ? (
                  <div>
                    {Object.entries(value.files).map(([k, v]) => {
                      if (v.options.length === 1) {
                        return (
                          <div key={`${k}-${i}`} style={{ marginBottom: 5 }}>
                            <div style={{ fontWeight: 'bold', display: 'inline-block' }}>{k}:</div> {v.selected.name}
                          </div>
                        );
                      } else {
                        return (
                          <div key={`${k}-${i}`} style={{ marginBottom: 5 }}>
                            <div style={{ fontWeight: 'bold', display: 'inline-block' }}>{k}:</div>
                            <select
                              onChange={(e) => {
                                e.preventDefault();
                                pairedFastQs[key].files[k].selected = v.options.find(
                                  (file: any) => file.name === e.target.value,
                                );
                                setSamplePairs(pairedFastQs);
                              }}
                            >
                              {v.options.map((file: any) => {
                                return (
                                  <option key={file.name} value={file.name}>
                                    {file.name}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        );
                      }
                    })}
                  </div>
                ) : (
                  <div>
                    {headerElement.options ? (
                      <select
                        style={{ width: `${headerElement.width - 10}px` }}
                        value={pairedFastQs[key][headerElement.id]}
                        onChange={(e) => {
                          e.preventDefault();
                          const updatedPairedFastQs = {
                            ...pairedFastQs,
                            [key]: {
                              ...pairedFastQs[key],
                              [headerElement.id]: e.target.value,
                            },
                          };
                          setSamplePairs(updatedPairedFastQs);
                        }}
                      >
                        {headerElement.options.map((option: string) => {
                          return (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          );
                        })}
                      </select>
                    ) : value[headerElement.id] ? (
                      <input
                        style={{ width: `calc(100% - 10px)` }}
                        type="text"
                        value={value[headerElement.id]}
                        onChange={(e) => {
                          e.preventDefault();
                          pairedFastQs[key] = { ...pairedFastQs[key], [headerElement.id]: e.target.value };
                          setSamplePairs(pairedFastQs);
                        }}
                      />
                    ) : (
                      <input
                        className={`${validationCheck && headerElement.required ? styles.invalidInput : ''}`}
                        style={{ width: `calc(100% - 10px)` }}
                        type="text"
                        placeholder={'Enter Value'}
                        onChange={(e) => {
                          e.preventDefault();
                          pairedFastQs[key] = { ...pairedFastQs[key], [headerElement.id]: e.target.value };
                          setSamplePairs(pairedFastQs);
                        }}
                      />
                    )}
                  </div>
                )}
              </td>
            );
          })}
          <td className={styles.actionsColumn}>
            <FontAwesomeIcon className={styles.modifyIcon} icon={['fas', 'pencil']} onClick={() => onRowClick(key)} />
          </td>
        </tr>
      );
    }),
  };

  return dataTable;
}

export function promptModifyFastQForm(
  displayName: string,
  rowEntry: any,
  selectedTemplate: uploadTemplate,
): Promise<any> {
  const form: TpAutoFormDef = {
    title: `Modify FASTQ Metadata for ${displayName}`,
    fields: selectedTemplate.fileSetMetadata.map((field: any) => {
      return {
        id: field.id,
        name: field.name,
        dataType: field.dataType,
        startContent: rowEntry[field.id],
        required: field.required,
      };
    }),
  };
  return promptAutoForm(form);
}
